import React, { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import { PayoutService, Spinner, Alert, ConfigService } from '../../services';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-loading-skeleton/dist/skeleton.css';
import ConfirmationPop from '../../components/ConfirmationPop';
import TaxOverview from '../tax-overview/TaxOverview';
import Pagination from '../../components/Pagination';
import NoDataFound from '../../components/NoDataFound';
import {
  CloseButtonSvgIcon,
  ClockIcon,
  ProcessingIcon,
} from '../../components/icons/IconProvider';
import { formatValue } from '../../utils/Helper';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router-dom';
import FormInput from '../../components/FormInput';
import SortByFilter from '../../components/listing/SortByFilter';
import SearchInput from '../../components/SearchInput';

const Payout = () => {
  const [showPayoutModal, setPayoutModal] = useState(false);
  const [showInterestModal, setshowInterestModal] = useState(false);
  const [isDividendData, setDividendData] = useState(null);
  const [showPayoutPreviewModel, setPayoutPreviewModel] = useState(false);
  const [projectPayoutList, setProjectPayoutList] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [isGenerateLoader, setGenerateLoader] = useState(false);
  const [projectPayoutListPreview, setProjectPayoutListPreview] = useState([]);

  const [projectPayoutPreviewDetails, setProjectPayoutPreviewDetails] =
    useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [perPage] = useState(10);

  const [startDate, setStartDate] = useState({
    startDate: null,
    endDate: null,
  });
  const [endDate, setEndDate] = useState(null);
  const [startNewDate, setNewStartDate] = useState(null);
  const [filterPayoutData, setFilterPayoutData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    status: '',
    investmentType: '',
  });

  const [payoutPreviewLoading, setPayoutPreviewLoading] = useState(false);
  const [page, setPage] = useState(1);

  //confirmarion modal
  const [isCommonConfirmationPop, setCommonConfirmationPop] = useState(false);
  const [isConfirmationPopData, setConfirmationPopData] = useState({
    FirstText: '',
    SecondText: '',
    FirstButton: '',
    secondButton: '',
    slug: '',
  });
  const [confirmationData, setConfirmationData] = useState(null);
  const [reload, setReload] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });
  const navigate = useNavigate();
  const schema = Yup.object({
    payout_amount: Yup.number()
      .typeError('Profit Amount is required.')
      .required('Profit Amount is required.')
      .nullable(),
    from_date: Yup.string().required('From date is required').nullable(),
    to_date: Yup.string().required('To date is required').nullable(),
  }).required();

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const generateDividendStart = async (_input) => {
    const generateDividend = {
      project_id: selectedProject?.id,
      payout_amount: _input?.payout_amount,
      from_date: startDate?.startDate
        ? startDate?.startDate
        : startNewDate?.startDate,
      to_date: endDate.endDate,
      perPage: perPage,
      page: 1,
    };

    setDividendData(generateDividend);
    setPage(1);
    generateDividendPreview(_input?.payout_amount);
  };

  const generateDividend = async () => {
    try {
      setGenerateLoader(true);
      const generateDividend = {
        project_id: selectedProject.id,
        payout_amount: isDividendData?.payout_amount,
        from_date:
          startDate?.startDate !== null
            ? moment(startDate?.startDate).format('YYYY-MM-DD')
            : startNewDate?.startDate,
        to_date: moment(endDate?.endDate).format('YYYY-MM-DD'),
      };

      let response = await PayoutService.generateDividend(generateDividend);

      if (response.status === 'failure') {
        setGenerateLoader(false);
        Alert.error(response.message);
        return false;
      }
      setPayoutPreviewModel(false);
      setNewStartDate(null);
      setEndDate(null);
      setGenerateLoader(false);
      Alert.success(response.message);
      setFilterPayoutData({
        ...filterPayoutData,
      });
      reset();
    } catch (error) {
      setGenerateLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  const getProjectPayoutList = async () => {
    try {
      setLoader(true);
      let fiatResponse = await PayoutService.getProjectPayoutList(
        filterPayoutData.perPage,
        page,
        filterPayoutData.commonSearch,
        filterPayoutData.investmentType,
        filterPayoutData.status,
      );
      if (fiatResponse.status === 'failure') {
        setLoader(false);
        Alert.error(fiatResponse.message);
        return false;
      }
      setPagination({
        totalPages: fiatResponse.data.pagination.totalPages,
        currentPage: fiatResponse.data.pagination.page,
      });
      // Filter the data based on the investment type
      let filteredData = fiatResponse.data.records;
      if (filterPayoutData.investmentType) {
        filteredData = filteredData.filter(
          (item) => item.investment_type === filterPayoutData.investmentType,
        );
      }
      setProjectPayoutList([...filteredData]);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      await getProjectPayoutList();
    })();
  }, [filterPayoutData, reload]);

  const updateStatus = async (projectId, PayoutId, value) => {
    try {
      const formData = {
        project_id: Number(projectId),
        payout_id: Number(PayoutId),
        payout_payment_status: Number(value),
      };
      let response = await PayoutService.updatePayoutStatus(formData);

      if (response.status === 'failure') {
        Alert.error(response.message);
        return false;
      }

      Alert.success(response.message);
      setFilterPayoutData({
        ...filterPayoutData,
      });
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const handleSelectChange = (projectId, PayoutId, e) => {
    const selectedValue = e.target.value;

    // Show confirmation popup
    setConfirmationPopData({
      FirstText: 'Payout Confirmation',
      SecondText:
        'On confirmation, an email will be sent to all the investors. Are you sure you want to mark this as paid?',
      FirstButton: 'No',
      secondButton: 'Yes',
      slug: 'redirect',
    });
    setCommonConfirmationPop(true);
    setConfirmationData({ projectId, PayoutId, selectedValue });
  };

  const confirmationPopHandel = async (confirmed) => {
    setCommonConfirmationPop(false);
    if (confirmed) {
      const { projectId, PayoutId, selectedValue } = confirmationData;
      await updateStatus(projectId, PayoutId, selectedValue);
    }
  };

  const closeModel = () => {
    setPage(1);
    setPayoutModal(false);
    setPayoutPreviewModel(false);
    setStartDate({ startDate: null, endDate: null });
    setNewStartDate({ startDate: null, endDate: null });
    setEndDate({ startDate: null, endDate: null });
    reset();
  };
  const generateDividendPreview = async (payout_amount = null) => {
    try {
      setPayoutPreviewLoading(true);
      const generateDividend = {
        project_id: selectedProject.id,
        payout_amount: payout_amount
          ? payout_amount
          : isDividendData?.payout_amount,
        from_date: startDate?.startDate
          ? startDate?.startDate
          : startNewDate?.startDate,
        to_date: endDate?.endDate,
      };
      let ownedAssetListRes =
        await PayoutService.generateDividendPreview(generateDividend);
      if (ownedAssetListRes.status === 'failure') {
        setPayoutPreviewLoading(false);
        Spinner.hide();
        Alert.error(ownedAssetListRes.message);
        return false;
      }

      setProjectPayoutListPreview(ownedAssetListRes.data.records);
      setProjectPayoutPreviewDetails(ownedAssetListRes.data.payoutInfo);

      setPayoutModal(false);
      reset();

      setPayoutPreviewModel(true);
      setPayoutPreviewLoading(false);
    } catch (error) {
      setPayoutPreviewLoading(false);
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const generatePayout = async (isPreview = true) => {
    try {
      isPreview ? setPayoutPreviewLoading(true) : setGenerateLoader(true);
      const _data = {
        project_id: selectedProject.id,
        isPreview: isPreview,
      };

      let response = await PayoutService.generatePayout(_data);
      if (response.status === 'failure') {
        isPreview ? setPayoutPreviewLoading(false) : setGenerateLoader(false);
        Alert.error(response.message);
        return false;
      }
      if (isPreview) {
        setProjectPayoutListPreview(response.data.records);
        setProjectPayoutPreviewDetails(response.data.payoutInfo);
        setshowInterestModal(false);

        setPayoutPreviewModel(true);
        setPayoutPreviewLoading(false);
      } else {
        setPayoutPreviewModel(false);
        setGenerateLoader(false);
        Alert.success(response.message);
        setFilterPayoutData({
          ...filterPayoutData,
        });
      }
    } catch (error) {
      isPreview ? setPayoutPreviewLoading(false) : setGenerateLoader(false);
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = (action, value) => {
    if (
      action === 'investmentType' &&
      value === filterPayoutData.investmentType
    )
      return false;
    setFilterPayoutData({
      ...filterPayoutData,
      ...(action === 'commonSearch' && { page: 1 }),
      ...(action === 'investmentType' && { commonSearch: '' }),
      [action]: value,
    });
  };

  const projectRepayment = async (project_id) => {
    try {
      Spinner.show();
      let response = await PayoutService.projectRepayment(project_id);
      if (response.status === 'failure') {
        Spinner.hide();
        Alert.error(response.message);
        return false;
      }
      Spinner.hide();
      Alert.success(response.message);
      setReload((prev) => !prev);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterPayoutData({
      ...filterPayoutData,
      page: current,
    });
  };

  const investmentType =
    filterPayoutData.investmentType === 'asset' ? 'Dividend' : 'Interest';

  const isPayoutPreviewListHeader = [
    { Name: 'User Name' },
    { Name: 'Email' },
    { Name: 'Tokens' },
    { Name: 'Payout' },
  ];

  const investedOptions = [
    { name: 'All Investment type', value: '' },
    { name: 'Equity', value: 'asset' },
    { name: 'Bond', value: 'bond' },
  ];

  const pageRedirect = (project_id, payout_id, _data) => {
    if (_data?.projectPayouts?.length > 0) {
      navigate('/payout/user-payout-list/' + project_id + '/' + payout_id);
    }
  };

  const payoutTableConfig = {
    columns: {
      project_name: {
        title: 'Project',
        render: (data) => {
          return (
            <div
              onClick={() =>
                pageRedirect(data?.id, data?.projectPayouts[0]?.id, data)
              }
              className="flex font-semibold text-md w-full h-full items-center"
            >
              <img
                src={data?.ProjectsTypes?.icon_url}
                className="mr-2"
                alt=""
              />{' '}
              {data?.name || 'NA'}
            </div>
          );
        },
      },
      investors_count: {
        title: 'Investors',
        render: (data) => {
          return (
            <div
              className="flex items-center"
              onClick={() =>
                pageRedirect(data?.id, data?.projectPayouts[0]?.id, data)
              }
            >
              {data?.totalInvestors || '0'}
            </div>
          );
        },
      },
      periods: {
        title: 'Periods',
        render: (data) => {
          return (
            <div
              onClick={() =>
                pageRedirect(data?.id, data?.projectPayouts[0]?.id, data)
              }
            >
              <span className=" inline-block">
                {(() => {
                  const payout = data?.projectPayouts?.[0];
                  if (!payout) return '';
                  const format = 'dmy';
                  return `${ConfigService.formatDate(payout.from_period, format)} - ${ConfigService.formatDate(payout.to_period, format)}`;
                })()}
              </span>
            </div>
          );
        },
      },
      payout_amount: {
        title: investmentType,
        render: (data, index) => {
          return (
            <>
              {data?.totalInvestors > 0 &&
              data?.projectPayouts?.length === 0 ? (
                <span className=" inline-block font-medium">
                  {data.investment_type === 'asset' ? (
                    <button
                      className="bg-brandBlue text-white py-2 px-3 text-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPayoutModal(true);
                        setSelectedProject(data);
                      }}
                    >
                      Generate Payout
                    </button>
                  ) : (
                    <button
                      className="bg-brandBlue text-white py-2 px-3 text-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProject(data);
                        setshowInterestModal(true);
                      }}
                    >
                      Generate Payout
                    </button>
                  )}
                </span>
              ) : (
                ''
              )}
              {data?.totalInvestors > 0 &&
              data?.projectPayouts &&
              data?.projectPayouts[0]?.status === 1 ? (
                <span className=" inline-block font-medium">
                  {data.investment_type === 'asset' ? (
                    <>
                      <button
                        data-tooltip-id={`error-msg-${index}`}
                        className={
                          moment().format('L') ===
                          moment(data?.projectPayouts[0]?.to_period).format('L')
                            ? 'bg-[#787a7d] font-semibold cursor-not-allowed text-white py-2 px-3 text-sm'
                            : 'bg-brandBlue text-white py-2 px-3 text-sm'
                        }
                        disabled={
                          moment().format('L') ===
                          moment(data?.projectPayouts[0]?.to_period).format('L')
                            ? true
                            : false
                        }
                        onClick={() => {
                          setPayoutModal(true);
                          setSelectedProject(data);
                          setStartDate({
                            startDate:
                              data?.projectPayouts &&
                              data?.projectPayouts[0]?.to_period
                                ? moment(
                                    data?.projectPayouts[0]?.to_period,
                                  ).add(1, 'day')
                                : null,
                            endDate:
                              data?.projectPayouts &&
                              data?.projectPayouts[0]?.to_period
                                ? moment(
                                    data?.projectPayouts[0]?.to_period,
                                  ).add(1, 'day')
                                : null,
                          });
                          setValue(
                            'from_date',
                            moment(data?.projectPayouts[0]?.to_period).add(
                              1,
                              'day',
                            ),
                            {
                              shouldValidate: true,
                              shouldDirty: true,
                            },
                          );
                        }}
                      >
                        Generate Payout
                      </button>
                      {moment().format('L') ===
                        moment(data?.projectPayouts[0]?.to_period).format(
                          'L',
                        ) && (
                        <ReactTooltip
                          id={`error-msg-${index}`}
                          place="bottom"
                          content="For the current date, payouts cannot be generated."
                        />
                      )}
                    </>
                  ) : moment(data?.projectPayouts[0]?.to_period).add(
                      1,
                      'day',
                    ) >= moment(data?.maturity_date) &&
                    data?.projectPayouts[0]?.status === 1 ? (
                    <>
                      <p data-tooltip-id={`payout-msg-${index}`}>
                        {data?.projectPayouts[0]
                          ? formatValue(data?.projectPayouts[0].payout_amount, {
                              decimaPlaces: 2,
                            })
                          : ''}
                      </p>
                    </>
                  ) : (
                    <>
                      <button
                        className="bg-brandBlue text-white py-2 px-3 text-sm"
                        onClick={() => {
                          setSelectedProject(data);
                          setshowInterestModal(true);
                        }}
                      >
                        Generate Payout
                      </button>
                    </>
                  )}
                </span>
              ) : data?.projectPayouts[0] ? (
                formatValue(data?.projectPayouts[0]?.payout_amount, {
                  decimaPlaces: 2,
                })
              ) : (
                ''
              )}
              {data.investment_type === 'bond' &&
              moment(data?.projectPayouts[0]?.to_period).add(1, 'day') >=
                moment(data?.maturity_date) ? (
                <ReactTooltip
                  id={`payout-msg-${index}`}
                  place="bottom"
                  content={
                    'This project maturity was completed on ' +
                    moment(data?.maturity_date).format('DD MMM YYYY') +
                    ' and all project payout payments have been settled.'
                  }
                />
              ) : (
                ' '
              )}
            </>
          );
        },
      },
      repayment_date: {
        title: 'Repayment',
        render: (data) => {
          return (
            <>
              {data?.investment_type === 'bond' &&
              data?.isMaturityReaches === true ? (
                <button
                  className={`bg-brandBlue text-white py-2 px-3 text-sm ${
                    data?.repaymentRecordsCount > 0
                      ? 'bg-gray-400 cursor-not-allowed'
                      : ''
                  }`}
                  onClick={() => {
                    projectRepayment(data.id);
                  }}
                  disabled={data?.repaymentRecordsCount > 0}
                >
                  Create Repayment
                </button>
              ) : null}
            </>
          );
        },
      },

      payout_payment_status: {
        title: 'Status',
        render: (data, index) => {
          return (
            <>
              {data?.projectPayouts?.[0]?.status === 0 ? (
                <select
                  onChange={(e) =>
                    handleSelectChange(data?.id, data?.projectPayouts[0]?.id, e)
                  }
                  value={data?.projectPayouts[0]?.status}
                  className="bg-yellowBadge text-black py-[2px] px-3 text-sm inline-block w-auto"
                >
                  <option value="0">Pending</option>
                  <option value="1">Paid</option>
                </select>
              ) : null}

              {data?.projectPayouts?.[0]?.status === 1 && (
                <span className="inline-block uppercase bg-GreenColor text-black py-[2px] px-3 rounded-md font-semibold text-xs">
                  Paid
                </span>
              )}

              {data?.projectPayouts?.[0]?.status !== 0 &&
                data?.projectPayouts?.[0]?.status !== 1 &&
                '-'}

              {data?.investment_type === 'bond' &&
              moment(data?.projectPayouts?.[0]?.to_period).add(1, 'day') >=
                moment(data?.maturity_date) ? (
                <ReactTooltip
                  id={`payout-msg-${index}`}
                  place="bottom"
                  content={
                    'This project maturity was completed on ' +
                    moment(data?.maturity_date).format('DD MMM YYYY') +
                    ' and all project payout payments have been settled.'
                  }
                />
              ) : (
                ' '
              )}
            </>
          );
        },
      },
    },
    data: projectPayoutList,
  };

  const payoutPreviewTableConfig = {
    columns: {
      full_name: {
        title: 'User Name',
        render: (data) => {
          return data?.full_name || '0';
        },
      },
      email: {
        title: 'Email',
        render: (data) => {
          return data?.email || 'NA';
        },
      },
      tokens: {
        title: 'Tokens',
        render: (data) => {
          return data?.totalQuantity || 'NA';
        },
      },
      payout: {
        title: 'Payout',
        render: (data) => {
          return (
            <div>
              {formatValue(data?.payoutAmount, {
                decimalPlaces: 2,
              }) || '0'}
            </div>
          );
        },
      },
    },
    data: projectPayoutListPreview,
  };

  return (
    <>
      <div className="">
        <h4 className="md:mb-4">Payout</h4>

        <div className="w-full bg-brandGray px-5 py-4 rounded-xl">
          <div className="grid grid-cols-1 items-center">
            <div className="md:flex items-center justify-end">
              <div className="flex bg-white items-center rounded-md md:ml-4 md:mr-2 mb-3 md:mb-0">
                <SortByFilter
                  value={filterPayoutData.investmentType}
                  dropdownList={investedOptions}
                  filterData={filterPayoutData}
                  setFilterData={setFilterPayoutData}
                  setPage={setPage}
                  fieldName="investmentType"
                />
              </div>

              <div className="lg:mx-2 inline-flex relative min-w-full md:min-w-[200px] mb-2 md:mb-0">
                <SearchInput
                  name="commonSearch"
                  id="commonSearch"
                  value={filterPayoutData?.commonSearch}
                  placeholder="Search Keyword"
                  onChange={(e) => {
                    searchData('commonSearch', e.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col relative overflow-x-auto w-full">
            <TableComponent
              tableConfig={payoutTableConfig}
              isListLoader={isLoader}
              isList={projectPayoutList}
            />
          </div>
          {projectPayoutList &&
            projectPayoutList.length > 0 &&
            isLoader === false && (
              <Pagination
                total={isPagination.totalPages}
                current={isPagination.currentPage}
                pagination={(crPage) => handlePagination(crPage)}
              />
            )}
          {projectPayoutList &&
            projectPayoutList.length === 0 &&
            isLoader === false && (
              <>
                <NoDataFound />
              </>
            )}
        </div>
        {showInterestModal && (
          <GeneratePayout
            setshowInterestModal={setshowInterestModal}
            selectedProject={selectedProject}
            payoutPreviewLoading={payoutPreviewLoading}
            generatePayout={generatePayout}
          />
        )}

        {showPayoutModal ? (
          <PayoutModal
            isOpen={showPayoutModal}
            closeModel={closeModel}
            onSubmit={generateDividendStart}
            register={register}
            control={control}
            errors={errors}
            handleSubmit={handleSubmit}
            payoutPreviewLoading={payoutPreviewLoading}
            ProcessingIcon={ProcessingIcon}
            startDate={startDate}
            setNewStartDate={setNewStartDate}
            setEndDate={setEndDate}
            setValue={setValue}
            startNewDate={startNewDate}
            endDate={endDate}
          />
        ) : null}

        {showPayoutPreviewModel && (
          <PayoutPreviewModel
            projectPayoutPreviewDetails={projectPayoutPreviewDetails}
            isPayoutPreviewListHeader={isPayoutPreviewListHeader}
            payoutPreviewLoading={payoutPreviewLoading}
            projectPayoutListPreview={projectPayoutListPreview}
            isLoader={isLoader}
            closeModel={closeModel}
            generateDividend={generateDividend}
            generatePayout={generatePayout}
            isGenerateLoader={isGenerateLoader}
            payoutPreviewTableConfig={payoutPreviewTableConfig}
          />
        )}

        {/* Tax Overview Code Start Here */}
        <TaxOverview />
        {/* Tax Overview Code Ends Here */}

        <ConfirmationPop
          isPop={isCommonConfirmationPop}
          setPop={setCommonConfirmationPop}
          functionCall={confirmationPopHandel}
          FirstText={isConfirmationPopData.FirstText}
          secondText={isConfirmationPopData.SecondText}
          FirstButton={isConfirmationPopData.FirstButton}
          secondButton={isConfirmationPopData.secondButton}
          slug={isConfirmationPopData.slug}
        />
      </div>
    </>
  );
};

export const GeneratePayout = ({
  setshowInterestModal,
  selectedProject,
  payoutPreviewLoading,
  generatePayout,
}) => {
  return (
    <>
      <div className="justify-center flex items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full mx-3 my-4 max-w-md z-30">
          <div className="bg-white rounded-2xl p-5">
            <div className="flex items-center justify-between mb-4">
              <h4>Generate Payout</h4>
              <button
                className="p-1 w-6 h-6"
                onClick={() => setshowInterestModal(false)}
              >
                <CloseButtonSvgIcon />
              </button>
            </div>

            {/* Last payout info */}
            {selectedProject?.lastPayout && (
              <div className="border border-gray-200 rounded-md text-sm flex items-center py-3 px-4 mb-3">
                <ClockIcon />
                <>
                  Last Payout was generated for{' '}
                  <span className="font-semibold ml-1">
                    {' '}
                    {selectedProject?.lastPayout?.from} to{' '}
                    {selectedProject?.lastPayout?.to}{' '}
                  </span>
                </>
              </div>
            )}

            {/* Content */}
            <div className="text-center">
              <p className="text-lg pb-3 border-b border-gray-200 mb-3">
                Payout period
                <br />
                <span className="font-bold">
                  {selectedProject?.nextPayout?.from
                    ? moment(selectedProject.nextPayout.from).format('ll')
                    : 'N/A'}{' '}
                  through{' '}
                  {selectedProject?.nextPayout?.to
                    ? moment(selectedProject.nextPayout.to).format('ll')
                    : 'N/A'}
                </span>
              </p>

              <p className="text-lg pb-3 mb-3">
                Total Interest Payable
                <br />
                <span className="font-bold">
                  {selectedProject?.nextPayout?.amount
                    ? formatValue(selectedProject?.nextPayout?.amount, {
                        decimalPlaces: 2,
                      })
                    : '€0'}
                </span>
              </p>

              {/* Button */}
              <button
                type="button"
                className={
                  payoutPreviewLoading
                    ? 'bg-[#787a7d] cursor-not-allowed text-brandBlue border border-[#787a7d] font-bold uppercase text-sm px-5 py-3 rounded-md w-auto inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150'
                    : 'bg-GreenColor text-brandBlue text-base font-semibold px-5 py-3 rounded-md'
                }
                onClick={generatePayout}
              >
                {payoutPreviewLoading ? (
                  <div className="flex items-center gap-2">
                    <ProcessingIcon />
                    Generating Preview
                  </div>
                ) : (
                  'Generate Payout'
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-20 bg-black"></div>
      </div>
    </>
  );
};

export const PayoutModal = ({
  closeModel,
  onSubmit,
  register,
  control,
  errors,
  handleSubmit: formHandleSubmit,
  payoutPreviewLoading,
  ProcessingIcon,
  startDate,
  setNewStartDate,
  setEndDate,
  setValue,
  startNewDate,
}) => {
  return (
    <>
      <div>
        <div className="justify-center flex items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full mx-3 my-4 max-w-md">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              {/*header*/}
              <div className="flex justify-between items-center py-3 px-6">
                <h3>Generate Payout</h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                  onClick={() => closeModel()}
                >
                  <span className="bg-transparent text-black w-10  block outline-none focus:outline-none">
                    <img
                      src="/img/closebutton.svg"
                      className="inline-block w-8"
                      alt=""
                    />
                  </span>
                </button>
              </div>
              {/*body*/}
              <form onSubmit={formHandleSubmit(onSubmit)}>
                <div className="py-3 px-6">
                  <div className="mb-4">
                    <FormInput
                      label="Amount (€)"
                      name="payout_amount"
                      type="number"
                      placeholder="Profit Amount"
                      register={register}
                      errors={errors}
                      max="10000000000000"
                      step="1"
                      min={1}
                      className="mb-2"
                      labelClassName="font-semibold"
                    />
                  </div>
                  <div className="mb-4">
                    <FormInput
                      type="date-picker"
                      label="From"
                      name="from_date"
                      control={control}
                      errors={errors}
                      placeholder="Select from date"
                      disabled={!!startDate?.startDate}
                      maxDate={new Date()}
                      onChange={(date) => {
                        setNewStartDate(date);
                        setEndDate({
                          startDate: null,
                          endDate: null,
                        });
                        setValue('from_date', date?.startDate, {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      }}
                    />
                  </div>
                  <div className="mb-4">
                    <FormInput
                      type="date-picker"
                      label="To"
                      name="to_date"
                      required={true}
                      control={control}
                      errors={errors}
                      placeholder="To date"
                      minDate={
                        startDate?.startDate === null
                          ? startNewDate?.startDate
                          : startDate?.startDate
                      }
                      maxDate={new Date()}
                      onChange={(date) => {
                        setEndDate(date);
                        setValue('to_date', date.endDate, {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="pb-6 px-6 text-center">
                  <button
                    className={` border text-brandBlue font-bold uppercase text-sm px-6 py-3 rounded-lg w-auto inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150 ${
                      payoutPreviewLoading
                        ? 'bg-[#787a7d] cursor-not-allowed   border-[#787a7d]'
                        : 'bg-GreenColor active:bg-[#92C24B] border-GreenColor'
                    }`}
                    disabled={payoutPreviewLoading}
                    type="submit"
                  >
                    {payoutPreviewLoading ? (
                      <div className="flex items-center gap-2">
                        <ProcessingIcon />
                        Generating
                      </div>
                    ) : (
                      'Generate'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </div>
    </>
  );
};

export const PayoutPreviewModel = ({
  projectPayoutPreviewDetails,
  payoutPreviewTableConfig,
  projectPayoutListPreview,
  isLoader,
  closeModel,
  generateDividend,
  generatePayout,
  isGenerateLoader,
}) => {
  return (
    <>
      <div>
        <div className="justify-center flex mx-4 items-start overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full mx-3 my-4 max-w-5xl">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none ">
              <div className="flex justify-between items-center py-3 px-6">
                <h3 className="pr-6">
                  Payout confirmation for{' '}
                  {projectPayoutPreviewDetails.projectName || 'NA'}
                </h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                  onClick={() => closeModel()}
                >
                  <span className="bg-transparent text-black w-10  block outline-none focus:outline-none">
                    <img
                      src="/img/closebutton.svg"
                      className="inline-block w-8"
                      alt=""
                    />
                  </span>
                </button>
              </div>

              <div className="w-full  px-5 pb-4 rounded-xl ">
                <div className="md:grid md:grid-cols-3 md:gap-4 bg-white border border-gray-100 py-2 px-4 rounded-lg">
                  <div className="mb-4 md:mb-0 ">
                    <p className="">Duration:</p>
                    <p className="font-semibold">
                      {' '}
                      {moment(projectPayoutPreviewDetails?.from).format(
                        projectPayoutPreviewDetails.payoutType === 'dividend'
                          ? `DD MMM YYYY`
                          : `DD MMM YYYY`,
                      )}{' '}
                      -{' '}
                      {moment(projectPayoutPreviewDetails?.to).format(
                        projectPayoutPreviewDetails.payoutType === 'dividend'
                          ? `DD MMM YYYY`
                          : `DD MMM YYYY`,
                      )}
                    </p>
                  </div>
                  <div className="mb-4 md:mb-0 ">
                    <p className="">Investors:</p>
                    <p className="font-semibold">
                      {projectPayoutPreviewDetails.totalInvestors || '0'}
                    </p>
                  </div>
                  <div className="">
                    <p className="">Total Payout:</p>
                    <p className="font-semibold">
                      {' '}
                      {projectPayoutPreviewDetails.totalPayout
                        ? formatValue(projectPayoutPreviewDetails.totalPayout, {
                            decimalPlaces: 2,
                          })
                        : '0.00'}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col relative overflow-x-auto w-full bg-gray-100 px-5 py-2">
                <TableComponent
                  tableConfig={payoutPreviewTableConfig}
                  isListLoader={isLoader}
                  isList={projectPayoutListPreview}
                />

                {projectPayoutListPreview &&
                  projectPayoutListPreview.length === 0 &&
                  isLoader === false && (
                    <>
                      <NoDataFound />
                    </>
                  )}
              </div>
              <div className="w-full bg-white text-right p-4 rounded-2xl">
                <button
                  onClick={() => {
                    closeModel();
                  }}
                  className="px-5 py-2 bg-white border border-gray-400 text-brandBlue rounded-lg mr-4 text-sm hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    projectPayoutPreviewDetails.payoutType === 'dividend'
                      ? generateDividend()
                      : generatePayout(false);
                  }}
                  className={`px-5 py-2  text-brandBlue border  rounded-lg text-sm
                      ${
                        isGenerateLoader
                          ? ' bg-[#787a7d] cursor-not-allowed border-[#787a7d]'
                          : ' bg-GreenColor  border-GreenColor'
                      }
                    `}
                  disabled={isGenerateLoader}
                >
                  {isGenerateLoader ? (
                    <div className="flex items-center gap-2">
                      <ProcessingIcon />
                      Generating
                    </div>
                  ) : (
                    'Confirm'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </div>
    </>
  );
};

export default Payout;
